module.exports = __webpack_public_path__ + "dc130dcb5cc165d32d20b01f14c7fad8.svg";